import { PART2_CONTENT, localize } from "@/data/part2Content";
import { getSessionContent } from "@/portal/portal";

export const pick = (obj, lang) => (obj && (obj[lang] || obj.en || obj.nl)) || "";

export const fmtDate = (iso, lang) => {
  if (!iso) return "";
  const loc = { en: "en-GB", nl: "nl-NL", bg: "bg-BG", uk: "uk-UA" }[lang] || "en-GB";
  return new Date(`${iso}T12:00:00`).toLocaleDateString(loc, { weekday: "long", day: "numeric", month: "long", year: "numeric" });
};

export const STAFF = ["admin", "trainer", "hr"];
export const isDayReady = (n) => !!PART2_CONTENT[n];
export const canOpenDay = (n, role) => isDayReady(n) || STAFF.includes(role);

const resolveSection = (s, lang) => {
  if (!s.ref) return localize(s, lang);
  const [session, idx] = s.ref;
  const sec = { ...getSessionContent(lang, session)[idx], session };
  if (s.omitBullets) sec.bullets = sec.bullets.filter((_, i) => !s.omitBullets.includes(i));
  if (s.omitCases) sec.cases = sec.cases.filter((c) => !s.omitCases.includes(c.number));
  if (s.omitQuestions) sec.questions = sec.questions.filter((q) => !s.omitQuestions.includes(q.id));
  return sec;
};

const resolveForm = (f, lang) => {
  if (!f.refWs) return localize(f, lang);
  const ws = getSessionContent(lang, f.refWs[0])[f.refWs[1]];
  return { id: f.id, title: ws.title, fields: ws.questions.map((q) => ({ id: q.id, type: "text", label: q.label })) };
};

export function getDayContent(n, lang) {
  const c = PART2_CONTENT[n];
  if (!c) return null;
  return {
    overview: localize(c.overview, lang),
    theory: c.theory.map((s) => resolveSection(s, lang)),
    quiz: c.quiz.map((s) => resolveSection(s, lang)),
    forms: c.forms.map((f) => resolveForm(f, lang)),
    homework: localize(c.homework, lang),
  };
}
